import React from "react";
import { AppBar, Toolbar, Button, Box, Divider, Tooltip } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/ge_vernova_logo.png";

const PRIMARY = "#005E60";
const ACTIVE = "#00c4cc";

const NAV_LINKS = [{ label: "Dashboard", path: "/" }];

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) =>
    path === "/"
      ? location.pathname === "/"
      : location.pathname.startsWith(path);

  const navBtn = (label, path) => (
    <Button
      key={path}
      onClick={() => navigate(path)}
      sx={{
        color: isActive(path) ? ACTIVE : "white",
        fontWeight: isActive(path) ? "bold" : "normal",
        borderBottom: isActive(path)
          ? `2px solid ${ACTIVE}`
          : "2px solid transparent",
        borderRadius: 0,
        paddingBottom: "4px",
        textTransform: "none",
        fontSize: "0.875rem",
        "&:hover": {
          color: ACTIVE,
          backgroundColor: "transparent",
        },
      }}
    >
      {label}
    </Button>
  );

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: PRIMARY,
        borderBottom: "3px solid #004749",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between", minHeight: "64px" }}>
        {/* ── Logo + Title ───────────────────────────────────── */}
        <Tooltip title="Go to Dashboard" placement="bottom">
          <Box
            onClick={() => navigate("/")}
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              gap: 1.5,
              "&:hover": { opacity: 0.85 },
              transition: "opacity 0.2s",
            }}
          >
            <img
              src={logo}
              alt="GE Vernova"
              style={{ height: 36, filter: "brightness(0) invert(1)" }}
            />
            <Divider
              orientation="vertical"
              flexItem
              sx={{ borderColor: "rgba(255,255,255,0.3)", mx: 1 }}
            />
            <Box>
              <Box
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
                  lineHeight: 1.2,
                }}
              >
                Advanced Concepts Team · Ship Power Systems Engineering
              </Box>
              <Box
                sx={{
                  color: "rgba(255,255,255,0.6)",
                  fontSize: "0.625rem",
                  letterSpacing: 1.5,
                  textTransform: "uppercase",
                }}
              >
                Engineering Specification Sheets
              </Box>
            </Box>
          </Box>
        </Tooltip>

        {/* ── Nav links ──────────────────────────────────────── */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {NAV_LINKS.map(({ label, path }) => navBtn(label, path))}
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
